import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  contentRoot: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
        display: "block",
    },
  },
  checkbox: {
    transform: "scale(1.5)",
    marginRight: theme.spacing(1),
  },
  payType: {
    flex: 1,
    flexBasis: "40%",
    [theme.breakpoints.down("md")]: {
      flex: "unset !important",
      flexBasis: "unset !important",
      width: "100% !important",
      maxWidth: "100% !important",
    },
   },
  payTypeTmp: {
    flex: 1,
    flexBasis: "60%"
  },
  payContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  details: {
    width: "100%"
  },
  rewardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    paddingLeft: "28px !important",
    [theme.breakpoints.down("md")]: {
      marginBottom: 16,
      paddingLeft: "8px !important",
      width: "100%",
    },
  },
  rewardsDropdown: {
    width: "100%",
  },
  pointsField: {
    marginTop: 0,
    marginBottom: 8,
  },
  pointsFieldClickable: {
    cursor: "pointer",
    "& input": {
      cursor: "pointer",
    },
  },
  pointsFieldDisabled: {
    cursor: "default",
    "& input": {
      cursor: "default",
    },
  },
}));
